(function () {
  // Guards against this file's own init running twice if it ends up
  // included from two places on the same page (e.g. espresso-buyboxes.liquid
  // and espresso-collections-header.liquid both present) -- otherwise every
  // click listener registered below would fire twice per click.
  if (window.__espressoLandingInit) return;
  window.__espressoLandingInit = true;

  const GRIND_ORDER = ["Espresso Grind", "Ground", "Whole Bean"];
  const GRIND_IMAGES = {
    "Espresso Grind": "https://espressono1.com/cdn/shop/files/icon-espresso-machine.webp?v=1779818265&width=120",
    Ground: "https://espressono1.com/cdn/shop/files/icon-rich-crema.webp?v=1779818266&width=120",
    "Whole Bean": "https://espressono1.com/cdn/shop/files/icon-roasted-after-you-order.webp?v=1779818298&width=120",
  };
  // Display-only relabel -- keeps the real variant option value ("Ground") untouched everywhere
  // else (data-grind-label, variant matching, cart line property), only the shopper-facing text changes.
  const GRIND_DISPLAY_LABELS = { Ground: "Filter Grind" };
  function grindDisplayLabel(label) {
    return GRIND_DISPLAY_LABELS[label] || label;
  }
  const SUBSCRIPTION_DISCOUNT = 0.1;

  // TEMP TEST FLAG -- overrides the landing page's displayed one-time total (per-bag price is
  // derived by dividing back) AND the SAVE badge amount, independently of each other, with test
  // values. Set to false to restore the real, verified Shopify per-bag discount amounts ($2/$3)
  // and flat SAVE amounts ($13.95/$25.98).
  const QB_TEST_OVERRIDE_BUNDLE_DISCOUNTS = false;
  const REAL_FLAT_BUNDLE_DISCOUNT_CENTS = { 1: 0, 3: 1695, 6: 3192 };
  const REAL_PACK_DISCOUNTS = { 1: 0, 3: 300, 6: 400 };
  const TEST_ONE_TIME_TOTAL_CENTS = { 3: 6295, 6: 11900 };
  const TEST_SAVINGS_CENTS = { 3: 1985, 6: 3868 };

  const productCache = new Map();
  const productFetchPromises = new Map();

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizeVariantLabel(value) {
    const raw = String(value || "").trim();
    if (!raw) return "";

    const parts = raw.split(/[·•|]/).map((part) => part.trim()).filter(Boolean);
    const head = parts[0] || raw;
    const compact = normalize(head);

    if (parts.length > 1) {
      const tail = normalize(parts.slice(1).join(" "));
      if (tail.includes("oz") || tail.includes("bag")) return compact;
    }

    return compact;
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    return "$" + amount.toFixed(2);
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);
    if (productFetchPromises.has(handle)) return productFetchPromises.get(handle);

    const promise = fetch(`/products/${handle}.js`, { headers: { Accept: "application/json" } })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((json) => {
        productCache.set(handle, json);
        productFetchPromises.delete(handle);
        return json;
      })
      .catch((error) => {
        productFetchPromises.delete(handle);
        throw error;
      });

    productFetchPromises.set(handle, promise);
    return promise;
  }

  function getProductHandleForQty(state, qty, allowFallback = true) {
    const exact = state.productHandles[String(qty)] || "";
    if (exact || !allowFallback) return exact;

    return state.productHandles["1"] || state.productHandles["3"] || state.productHandles["6"] || "";
  }

  function getBasePrice(product) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return 0;
    const variantWithPrice = product.variants.find((v) => typeof v.price === "number" || typeof v.price === "string");
    const raw = variantWithPrice ? variantWithPrice.price : product.variants[0].price;
    const cents = Number(raw || 0);
    return Number.isFinite(cents) ? cents : 0;
  }

  function findGrindOptionIndex(product) {
    if (!product || !Array.isArray(product.options)) return -1;
    const byName = product.options.findIndex((opt) => {
      const name = typeof opt === "string" ? opt : opt && opt.name ? opt.name : "";
      return normalize(name).includes("grind");
    });
    if (byName !== -1) return byName;

    const targetSet = new Set(GRIND_ORDER.map(normalize));
    const variants = Array.isArray(product.variants) ? product.variants : [];
    for (let i = 0; i < product.options.length; i += 1) {
      const values = new Set();
      variants.forEach((v) => {
        if (Array.isArray(v.options) && v.options[i]) values.add(normalizeVariantLabel(v.options[i]));
        if (!Array.isArray(v.options)) {
          const optionValue = i === 0 ? v.option1 : i === 1 ? v.option2 : v.option3;
          if (optionValue) values.add(normalizeVariantLabel(optionValue));
        }
      });
      if ([...values].some((v) => targetSet.has(v))) return i;
    }
    return -1;
  }

  function variantForGrind(product, grindLabel, grindOptionIndex) {
    if (!product || !Array.isArray(product.variants) || grindOptionIndex < 0) return null;
    const target = normalize(grindLabel);
    return (
      product.variants.find((variant) => {
        let value = "";
        if (Array.isArray(variant.options) && variant.options[grindOptionIndex]) {
          value = variant.options[grindOptionIndex];
        } else if (grindOptionIndex === 0) {
          value = variant.option1 || "";
        } else if (grindOptionIndex === 1) {
          value = variant.option2 || "";
        } else if (grindOptionIndex === 2) {
          value = variant.option3 || "";
        }
        return normalizeVariantLabel(value) === target || normalize(value) === target;
      }) || null
    );
  }

  function variantForGrindAnyOption(product, grindLabel) {
    if (!product || !Array.isArray(product.variants)) return null;
    const target = normalize(grindLabel);
    return (
      product.variants.find((variant) => {
        const values = [];
        if (Array.isArray(variant.options)) values.push(...variant.options);
        values.push(variant.option1, variant.option2, variant.option3);
        return values.some((v) => normalizeVariantLabel(v) === target || normalize(v) === target);
      }) || null
    );
  }

  function findVariantByGrind(product, grindLabel) {
    const grindOptionIndex = findGrindOptionIndex(product);
    const direct = variantForGrind(product, grindLabel, grindOptionIndex);
    return direct || variantForGrindAnyOption(product, grindLabel);
  }

  function getFirstAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find((variant) => variant && variant.available !== false) || product.variants[0] || null;
  }

  function getVariantAllocations(variant) {
    return Array.isArray(variant?.selling_plan_allocations) ? variant.selling_plan_allocations : [];
  }

  function cleanSellingPlanTitle(value) {
    const raw = String(value || "").trim();
    if (!raw) return "";

    const lower = raw.toLowerCase();
    const subscriptionIndex = lower.lastIndexOf("subscription:");
    let title = subscriptionIndex !== -1 ? raw.slice(subscriptionIndex + "subscription:".length) : raw;

    title = title.trim();

    const shipsIndex = title.toLowerCase().indexOf("ships every");
    if (shipsIndex !== -1) {
      title = title.slice(shipsIndex);
    }

    return title.replace(/\s+/g, " ").trim();
  }

  function formatSellingPlanLabel(value) {
    const raw = cleanSellingPlanTitle(value);
    const match = raw.match(/(\d+)\s*(week|weeks|month|months)\b/i);
    if (!match) return raw;

    const count = Number(match[1]);
    const unit = match[2].toLowerCase().startsWith("month") ? "month" : "week";
    const plural = count === 1 ? unit : `${unit}s`;
    return `${count} ${plural}`;
  }

  function getSellingPlanMetaMap(product) {
    const map = new Map();
    const groups = Array.isArray(product?.selling_plan_groups) ? product.selling_plan_groups : [];

    groups.forEach((group) => {
        const plans = Array.isArray(group?.selling_plans) ? group.selling_plans : [];
        plans.forEach((plan) => {
          const id = String(plan?.id || "");
          if (!id) return;
          const title =
            cleanSellingPlanTitle(plan?.name) ||
            cleanSellingPlanTitle(plan?.options?.[0]?.value) ||
            cleanSellingPlanTitle(plan?.options?.[0]) ||
            "";
          map.set(id, title);
        });
    });

    return map;
  }

  function cardHtml(label, variant, isSelected) {
    const isAvailable = Boolean(variant && variant.available);
    const image = GRIND_IMAGES[label] || "";
    const checkIcon = `
      <div class="tw:absolute tw:right-3 tw:top-3 tw:text-[#a26a21] espresso-check-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path>
        </svg>
      </div>`;

    return `
      <article
        class="tw:relative tw:rounded-brand tw:border tw:p-4 tw:text-center espresso-grind-card espresso-select-card ${
          isAvailable ? "" : "tw:opacity-50"
        } ${isSelected && isAvailable ? "is-selected" : ""}"
        data-step-2-card
        data-grind-label="${label}"
        data-variant-id="${variant ? variant.id : ""}"
        ${isAvailable ? "" : 'aria-disabled="true"'}
      >
        ${checkIcon}
        ${image ? `<img src="${image}" alt="${grindDisplayLabel(label)}" class="tw:mx-auto tw:mb-2 tw:h-[50px] tw:w-auto tw:max-w-full tw:md:mb-3 tw:md:h-[100px]" loading="lazy">` : ""}
        <div class="tw:text-base tw:md:text-lg tw:font-bold tw:leading-tight tw:uppercase">${grindDisplayLabel(label)}</div>
      </article>
    `;
  }

  function setStep1Selection(root, handle) {
    root.querySelectorAll("[data-step-1-card]").forEach((card) => {
      const isSelected = card.getAttribute("data-product-handle") === handle;
      card.classList.toggle("is-selected", isSelected);
    });
  }

  function setStep2Selection(root, label) {
    root.querySelectorAll("[data-step-2-card]").forEach((card) => {
      const isSelected = normalize(card.getAttribute("data-grind-label")) === normalize(label);
      const isDisabled = card.getAttribute("aria-disabled") === "true";
      card.classList.toggle("is-selected", isSelected && !isDisabled);
    });
  }

  function setStep3Selection(root, qty) {
    root.querySelectorAll("[data-step-3-card]").forEach((card) => {
      const cardQty = Number(card.getAttribute("data-qty") || 0);
      card.classList.toggle("is-selected", cardQty === Number(qty));
    });
  }

  function setPurchaseSelection(root, purchaseType) {
    root.querySelectorAll("[data-purchase-card]").forEach((card) => {
      const type = card.getAttribute("data-purchase-type") || "";
      card.classList.toggle("is-selected", type === purchaseType);
    });
  }

  function initBuyboxes(root) {
    const purchaseHidden = root.querySelector("[data-purchase-option-hidden]");

    const state = {
      productHandles: { "1": "", "3": "", "6": "" },
      lockCartQuantities: { "1": false, "3": false, "6": false },
      selectedPackSize: 3,
      selectedProduct: null,
      selectedVariant: null,
      selectedGrind: GRIND_ORDER[0],
      // Seeded from the Liquid-rendered default (espresso-step-3.liquid's default_purchase_type)
      // instead of a hardcoded literal, so a non-subscription default actually takes effect.
      purchaseType: purchaseHidden?.value === "onetime" ? "onetime" : "subscription",
      selectedSellingPlanId: "",
      selectedSellingPlanName: "",
      selectionToken: 0,
    };

    const frequencyWrap = root.querySelector("[data-frequency-wrap]");
    const frequencySelect = root.querySelector("[data-frequency-select]");
    const sellingPlanHidden = root.querySelector("[data-selling-plan-hidden]");
    const buyboxCta = root.querySelector("[data-buybox-cta]");
    const buyboxCtaLabel = buyboxCta ? buyboxCta.querySelector("span") : null;

    function setReadyState() {
      const ready = Boolean(state.selectedVariant) && (state.purchaseType !== "subscription" || Boolean(state.selectedSellingPlanId));
      if (buyboxCta) {
        buyboxCta.disabled = !ready;
        buyboxCta.setAttribute("aria-disabled", ready ? "false" : "true");
      }
    }

    function updateCtaLabel() {
      if (!buyboxCtaLabel) return;
      const isSubscription = state.purchaseType === "subscription";
      const actionLabel = isSubscription ? "Start Subscription" : "Add to Cart";

      // Price no longer shown on the CTA button -- was: append "- $X.XX" from the selected
      // pack's total, read via data-step3-total.
      // const qty = Number(state.selectedPackSize) || 1;
      // const card = root.querySelector(`[data-step-3-card][data-qty="${qty}"]`);
      // const totalNode = card ? card.querySelector("[data-step3-total]") : null;
      // const priceText = totalNode ? totalNode.textContent.replace(/^\$/, "") : "";
      // buyboxCtaLabel.textContent = priceText ? `${actionLabel} - $${priceText}` : actionLabel;

      buyboxCtaLabel.textContent = actionLabel;
    }

    async function loadPackProduct(qty) {
      const handle = getProductHandleForQty(state, qty, false);
      if (!handle) return null;
      return fetchProduct(handle);
    }

    async function updateStep3Pricing() {
      const tokenAtStart = state.selectionToken;
      const originalHandle = getProductHandleForQty(state, 1, false);
      if (!originalHandle) return;

      let baseProduct = null;
      try {
        baseProduct = await fetchProduct(originalHandle);
      } catch (error) {
        console.error("[espresso-landing] Failed to load base pack price", error);
        return;
      }

      if (tokenAtStart !== state.selectionToken) return;

      const originalPrice = getBasePrice(baseProduct);
      const isSubscription = state.purchaseType === "subscription";

      // The 3-bag/6-bag landing page "bundle" products are separate duplicate SKUs. Their
      // displayed total/per-bag price is set by the merchant to land on the same numbers as
      // this per-bag-off formula, but their real Shopify-tracked automatic discount ("3-Bags
      // Bundle Promotion + FREE SHIPPING", etc.) is a flat dollar amount that only applies once
      // the item is actually in the cart -- the Product API used for this live preview can't
      // see it ahead of time, so it's hardcoded here to drive the SAVE badge. Confirmed live:
      // $13.95 for 3 bags, $25.98 for 6 bags.
      const testTotal = QB_TEST_OVERRIDE_BUNDLE_DISCOUNTS ? TEST_ONE_TIME_TOTAL_CENTS : null;

      [1, 3, 6].forEach((qty) => {
        const card = root.querySelector(`[data-step-3-card][data-qty="${qty}"]`);
        if (!card) return;

        let basePerBagCents;
        let baseLineCents;
        if (testTotal && testTotal[qty]) {
          // Test total doesn't divide evenly by quantity ($62.95 / 3, $119.00 / 6), so set the
          // total directly and derive per-bag price by dividing back, instead of the usual
          // per-bag-discount-times-quantity direction.
          baseLineCents = testTotal[qty];
          basePerBagCents = Math.round(baseLineCents / qty);
        } else {
          basePerBagCents = Math.max(originalPrice - (REAL_PACK_DISCOUNTS[qty] || 0), 0);
          baseLineCents = basePerBagCents * qty;
        }
        const packPrice = isSubscription ? Math.round(basePerBagCents * 0.9) : basePerBagCents;
        const total = isSubscription ? Math.round(baseLineCents * 0.9) : baseLineCents;

        const perBagNode = card.querySelector("[data-step3-perbag]");
        const totalNode = card.querySelector("[data-step3-total]");
        if (perBagNode) perBagNode.textContent = formatMoney(packPrice);
        if (totalNode) totalNode.textContent = formatMoney(total);

        // "SAVE $X" -- the flat discount (test or real), plus the subscription discount stacked
        // on top of it when subscription is the active purchase type. Independent of the total
        // above -- doesn't have to reconcile to "list price minus total".
        const savingsNode = card.querySelector("[data-step3-savings]");
        if (savingsNode) {
          const flatSavingsCents = QB_TEST_OVERRIDE_BUNDLE_DISCOUNTS
            ? TEST_SAVINGS_CENTS[qty] || 0
            : REAL_FLAT_BUNDLE_DISCOUNT_CENTS[qty] || 0;
          const savingsCents = flatSavingsCents + (isSubscription ? baseLineCents - total : 0);
          savingsNode.textContent = (savingsCents / 100).toFixed(2);
        }
      });

      updateCtaLabel();
    }

    function syncPurchaseUi() {
      if (purchaseHidden) purchaseHidden.value = state.purchaseType;
      setPurchaseSelection(root, state.purchaseType);

      const allocations = getVariantAllocations(state.selectedVariant);
      const sellingPlanMetaMap = getSellingPlanMetaMap(state.selectedProduct);
      if (state.purchaseType !== "subscription" || !allocations.length) {
        if (state.purchaseType !== "subscription") {
          if (purchaseHidden) purchaseHidden.value = "onetime";
        }
        if (frequencySelect) {
          frequencySelect.disabled = true;
        }
        state.selectedSellingPlanId = "";
        state.selectedSellingPlanName = "";
        if (sellingPlanHidden) sellingPlanHidden.value = "";
        setPurchaseSelection(root, state.purchaseType);
        setReadyState();
        return;
      }

      if (frequencySelect) {
        frequencySelect.disabled = false;
        frequencySelect.innerHTML = "";

        const planDays = (allocation) => {
          const label = String(
            sellingPlanMetaMap.get(String(allocation.selling_plan_id || "")) || allocation.selling_plan_name || ""
          ).toLowerCase();
          const match = label.match(/(\d+)\s*(week|month|day)/);
          if (!match) return Number.MAX_SAFE_INTEGER;
          const multiplier = match[2] === "month" ? 30 : match[2] === "week" ? 7 : 1;
          return Number(match[1]) * multiplier;
        };
        const sortedAllocations = allocations.slice().sort((a, b) => planDays(a) - planDays(b));

        sortedAllocations.forEach((allocation, index) => {
          const option = document.createElement("option");
          option.value = String(allocation.selling_plan_id || "");
          option.textContent =
            formatSellingPlanLabel(sellingPlanMetaMap.get(String(allocation.selling_plan_id || "")) || allocation.selling_plan_name) ||
            `Delivery option ${index + 1}`;
          frequencySelect.appendChild(option);
        });

        const preferredDefaultAllocation = allocations.find((allocation) => {
          const label = String(
            sellingPlanMetaMap.get(String(allocation.selling_plan_id || "")) || allocation.selling_plan_name || ""
          ).toLowerCase();
          return label.includes("4 week") || label.includes("4-week") || label.includes("28 day");
        });
        const defaultAllocation =
          preferredDefaultAllocation || allocations[allocations.length - 1] || allocations[0];
        const selectedAllocation = allocations.find(
          (allocation) => String(allocation.selling_plan_id) === String(state.selectedSellingPlanId)
        );
        const preferredId = selectedAllocation
          ? String(selectedAllocation.selling_plan_id)
          : String(defaultAllocation?.selling_plan_id || "");
        state.selectedSellingPlanId = preferredId;
        state.selectedSellingPlanName =
          formatSellingPlanLabel(
            sellingPlanMetaMap.get(preferredId) ||
              (selectedAllocation && selectedAllocation.selling_plan_name) ||
              (defaultAllocation && defaultAllocation.selling_plan_name) ||
              ""
          ) ||
          (frequencySelect.options[frequencySelect.selectedIndex] && frequencySelect.options[frequencySelect.selectedIndex].textContent) ||
          "";
        frequencySelect.value = preferredId;
      }

      if (sellingPlanHidden) sellingPlanHidden.value = state.selectedSellingPlanId;
      setReadyState();
    }

    function applyVariant(variant) {
      state.selectedVariant = variant || null;
      state.selectedSellingPlanId = "";
      state.selectedSellingPlanName = "";
      syncPurchaseUi();
      setReadyState();
    }

    async function selectPackSize(qty) {
      state.selectionToken += 1;
      const tokenAtStart = state.selectionToken;
      state.selectedPackSize = qty;
      setStep3Selection(root, qty);
      updateCtaLabel();

      const product = await loadPackProduct(qty);
      if (tokenAtStart !== state.selectionToken) return;

      state.selectedProduct = product;
      const selectedVariant = findVariantByGrind(product, state.selectedGrind) || getFirstAvailableVariant(product);
      applyVariant(selectedVariant);
      renderStep2(root, product, state.selectedGrind);
      setStep2Selection(root, state.selectedGrind);
      syncPurchaseUi();
      await updateStep3Pricing();
    }

    function setHandlesFromCard(card) {
      const readBool = (value) => value === "true" || value === "1" || value === true || value === 1;
      state.productHandles = {
        "1": card.getAttribute("data-product-handle-1") || card.getAttribute("data-product-handle") || "",
        "3": card.getAttribute("data-product-handle-3") || "",
        "6": card.getAttribute("data-product-handle-6") || "",
      };
      state.lockCartQuantities = {
        "1": readBool(card.getAttribute("data-lock-cart-quantity-1")),
        "3": readBool(card.getAttribute("data-lock-cart-quantity-3")),
        "6": readBool(card.getAttribute("data-lock-cart-quantity-6")),
      };
    }

    async function pickProduct(card) {
      setHandlesFromCard(card);
      const displayHandle = card.getAttribute("data-product-handle") || "";
      setStep1Selection(root, displayHandle);

      state.selectedGrind = GRIND_ORDER[0];
      const preferredPack = state.productHandles[String(state.selectedPackSize)]
        ? state.selectedPackSize
        : (state.productHandles["1"] ? 1 : state.productHandles["3"] ? 3 : 6);
      await selectPackSize(preferredPack);
    }

    root.addEventListener("click", async (event) => {
      const step1Card = event.target.closest("[data-step-1-card]");
      if (step1Card && root.contains(step1Card)) {
        await pickProduct(step1Card);
        return;
      }

      const step2Card = event.target.closest("[data-step-2-card]");
      if (step2Card && root.contains(step2Card)) {
        if (step2Card.getAttribute("aria-disabled") === "true") return;
        state.selectedGrind = step2Card.getAttribute("data-grind-label") || GRIND_ORDER[0];
        setStep2Selection(root, state.selectedGrind);
        const selectedVariant = findVariantByGrind(state.selectedProduct, state.selectedGrind) || getFirstAvailableVariant(state.selectedProduct);
        applyVariant(selectedVariant);
        await updateStep3Pricing();
        return;
      }

      const step3Card = event.target.closest("[data-step-3-card]");
      if (step3Card && root.contains(step3Card)) {
        await selectPackSize(Number(step3Card.getAttribute("data-qty") || 1));
        return;
      }

      const purchaseCard = event.target.closest("[data-purchase-card]");
      if (purchaseCard && root.contains(purchaseCard)) {
        state.purchaseType = purchaseCard.getAttribute("data-purchase-type") || "subscription";
        syncPurchaseUi();
        await updateStep3Pricing();
      }
    });

    if (frequencySelect) {
      frequencySelect.addEventListener("change", () => {
        state.selectedSellingPlanId = frequencySelect.value || "";
        const selectedOption = frequencySelect.options[frequencySelect.selectedIndex];
        state.selectedSellingPlanName = selectedOption ? selectedOption.textContent || "" : "";
        if (sellingPlanHidden) sellingPlanHidden.value = state.selectedSellingPlanId;
        setReadyState();
      });
    }

    if (buyboxCta) {
      buyboxCta.addEventListener("click", async (event) => {
        event.preventDefault();

        if (!state.selectedVariant || (state.purchaseType === "subscription" && !state.selectedSellingPlanId)) {
          (root.querySelector("[data-step-1-card]") || root).scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }

        const payload = {
          id: state.selectedVariant.id,
          quantity: state.selectedPackSize || 1,
          properties: {
            _purchase_option: state.purchaseType,
            _pack_size: String(state.selectedPackSize),
            _selected_grind: state.selectedGrind,
          },
        };

        if (state.lockCartQuantities[String(state.selectedPackSize)]) {
          payload.properties._lock_cart_quantity = "true";
        }

        if (state.purchaseType === "subscription" && state.selectedSellingPlanId) {
          const sellingPlanId = Number(state.selectedSellingPlanId);
          payload.selling_plan = Number.isFinite(sellingPlanId) && sellingPlanId > 0 ? sellingPlanId : state.selectedSellingPlanId;
          payload.properties._delivery_frequency = state.selectedSellingPlanName || "";
        }

        try {
          if (window.ensureShippingProtectionBeforeAdd) {
            await window.ensureShippingProtectionBeforeAdd(payload.selling_plan || null);
          }

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
          });

          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          if (window.ensureShippingProtection) {
            await window.ensureShippingProtection(payload.selling_plan || null);
          }

          const cartTrigger = document.querySelector(".site-header-cart--button");
          if (cartTrigger) {
            cartTrigger.click();
          }
        } catch (error) {
          console.error("[espresso-landing] Failed to add item to cart", error);
        }
      });
    }

    const firstProductCard = root.querySelector("[data-step-1-card]");
    if (firstProductCard) {
      pickProduct(firstProductCard);
    }

    setStep3Selection(root, state.selectedPackSize);
    syncPurchaseUi();
    updateCtaLabel();
    updateStep3Pricing();
    setReadyState();
  }

  function renderStep2(root, product, selectedGrind) {
    const container = root.querySelector("[data-step-2-cards]");
    if (!container || !product) return;

    container.innerHTML = GRIND_ORDER.map((label) => {
      const variant = findVariantByGrind(product, label);
      return cardHtml(label, variant, normalize(label) === normalize(selectedGrind));
    }).join("");
  }

  // Bundle quick-add modal (espresso-bundle-quickshop.liquid + the
  // data-bundle-quickshop-trigger button in espresso-bundle-card.liquid).
  // Reuses fetchProduct/findVariantByGrind/findGrindOptionIndex from the
  // buyboxes widget above instead of duplicating any of that logic.
  //
  // One-time purchase only, deliberately -- Shopify Bundles (the app these
  // bundle products are built with) doesn't support selling plans at all;
  // confirmed via both Shopify's own docs and the cart API 422-ing on a
  // selling_plan for these specific products. No subscription/frequency UI
  // here until that changes.
  function initBundleQuickshop() {
    const modal = document.querySelector("[data-bundle-quickshop-modal]");
    if (!modal) return;

    const imageEl = modal.querySelector("[data-bundle-quickshop-image]");
    const nameEl = modal.querySelector("[data-bundle-quickshop-name]");
    const sublineEl = modal.querySelector("[data-bundle-quickshop-subline]");
    const priceEl = modal.querySelector("[data-bundle-quickshop-price]");
    const savingsEl = modal.querySelector("[data-bundle-quickshop-savings]");
    const freeShippingWrap = modal.querySelector("[data-bundle-quickshop-free-shipping]");
    const freeShippingTextEl = modal.querySelector("[data-bundle-quickshop-free-shipping-text]");
    const grindSelect = modal.querySelector("[data-bundle-quickshop-grind]");
    const addToCartBtn = modal.querySelector("[data-bundle-quickshop-add-to-cart]");

    const state = {
      product: null,
      variant: null,
      loadToken: 0,
      subline: "",
      bagCount: "",
    };

    function applyGrind(grindLabel) {
      state.variant = findVariantByGrind(state.product, grindLabel) || getFirstAvailableVariant(state.product);
    }

    function populateGrind() {
      if (!grindSelect || !state.product) return;
      const grindOptionIndex = findGrindOptionIndex(state.product);
      const optionObj = grindOptionIndex >= 0 ? state.product.options[grindOptionIndex] : null;
      const values = optionObj && Array.isArray(optionObj.values) ? optionObj.values : [];

      grindSelect.innerHTML = "";
      let firstAvailableValue = "";
      values.forEach((value) => {
        const variant = findVariantByGrind(state.product, value);
        const option = document.createElement("option");
        option.value = value;
        option.textContent = String(value).split("·")[0].trim();
        if (variant && variant.available === false) {
          option.disabled = true;
        } else if (!firstAvailableValue) {
          firstAvailableValue = value;
        }
        grindSelect.appendChild(option);
      });

      const initialValue = firstAvailableValue || values[0] || "";
      if (initialValue) {
        grindSelect.value = initialValue;
        applyGrind(initialValue);
      }
    }

    function close() {
      modal.classList.add("tw:hidden");
      modal.classList.remove("tw:flex");
      document.body.style.overflow = "";
    }

    async function open(trigger) {
      state.subline = trigger.getAttribute("data-subline") || "";
      state.bagCount = trigger.getAttribute("data-bag-count") || "";
      if (nameEl) nameEl.textContent = trigger.getAttribute("data-name") || "";
      if (sublineEl) sublineEl.textContent = state.subline;
      if (priceEl) priceEl.textContent = trigger.getAttribute("data-price") || "";

      const savingsText = trigger.getAttribute("data-savings-text") || "";
      if (savingsEl) {
        savingsEl.textContent = savingsText;
        savingsEl.style.display = savingsText ? "" : "none";
      }

      if (imageEl) {
        imageEl.src = trigger.getAttribute("data-image") || "";
        imageEl.alt = trigger.getAttribute("data-name") || "";
      }

      const freeShipping = trigger.getAttribute("data-free-shipping") === "true";
      if (freeShippingWrap) freeShippingWrap.style.display = freeShipping ? "" : "none";
      if (freeShippingTextEl) freeShippingTextEl.textContent = trigger.getAttribute("data-free-shipping-text") || "";

      modal.classList.remove("tw:hidden");
      modal.classList.add("tw:flex");
      document.body.style.overflow = "hidden";

      const handle = trigger.getAttribute("data-handle");
      const tokenAtStart = ++state.loadToken;
      if (grindSelect) grindSelect.innerHTML = '<option>Loading…</option>';

      try {
        const product = await fetchProduct(handle);
        if (tokenAtStart !== state.loadToken) return;
        state.product = product;
        populateGrind();
      } catch (error) {
        console.error("[espresso-landing] Failed to load bundle product", error);
      }
    }

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-bundle-quickshop-trigger]");
      if (trigger) {
        event.preventDefault();
        open(trigger);
        return;
      }

      if (event.target.closest("[data-bundle-quickshop-close]")) {
        close();
        return;
      }

      if (event.target === modal) {
        close();
      }
    });

    if (grindSelect) {
      grindSelect.addEventListener("change", () => applyGrind(grindSelect.value));
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") close();
    });

    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", async () => {
        if (!state.variant) return;

        const payload = {
          id: state.variant.id,
          quantity: 1,
        };

        // Line-item properties, not a product metafield: the bundle only ever gets added to
        // cart through this modal today, so this is the simplest way to carry "what's
        // actually in this bundle" through to the cart/checkout line item. cart-item.liquid
        // (full cart page) and side-cart.js (the drawer) both read these back out --
        // _bundle_contents for the descriptive note, _bundle_bag_count so the drawer can
        // show "3 Bag Bundle" instead of "1 bag" (these are Shopify Bundles-app composite
        // products added as qty 1, not the older same-flavor 3/6-bag duplicate SKUs the
        // drawer's bundle detection was originally built around).
        if (state.subline) {
          payload.properties = {
            _bundle_contents: state.subline,
            _bundle_bag_count: state.bagCount,
          };
        }

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
          });

          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          close();

          const cartTrigger = document.querySelector(".site-header-cart--button");
          if (cartTrigger) cartTrigger.click();
        } catch (error) {
          console.error("[espresso-landing] Failed to add bundle to cart", error);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-espresso-buyboxes]").forEach(initBuyboxes);
    initBundleQuickshop();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
